import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=4d477cee&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"
import style0 from "./Lobby.vue?vue&type=style&index=0&id=4d477cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d477cee",
  null
  
)

export default component.exports